import React, { useState, useEffect } from 'react'
import OrderDeliveryForm from "./OrderDeliveryForm";
import { Column, Row } from 'simple-flexbox';
import { Paper, makeStyles, TableBody, TableRow, TableCell, Toolbar, InputAdornment } from '@material-ui/core';
import useTable from "../../../utilities/useTable";
import { ToastContainer } from 'react-toastify';
import StatComponent from '../../stat-page/StatComponent';
import 'react-toastify/dist/ReactToastify.css';
import { connect } from "react-redux";
import Controls from "../../../controls/Controls";
import { Search } from "@material-ui/icons";
import AddIcon from '@material-ui/icons/Add';
import Popup from "../../../utilities/Popup";
import EditOutlinedIcon from '@material-ui/icons/EditOutlined';
import CloseIcon from '@material-ui/icons/Close';
import Notification from "../../../utilities/Notification";
import ConfirmDialog from "../../../utilities/ConfirmDialog";
import AddOrderDeliveryForm from './AddOrderDeliveryForm';


const useStyles = makeStyles(theme => ({
    pageContent: {
        margin: theme.spacing(5),
        padding: theme.spacing(3)
    },
    searchInput: {
        width: '75%'
    },
    newButton: {
        position: 'absolute',
        right: '10px'
    }
}))


const headCells = [
    { id: 'timeSpan', label: 'Time Span(Days)' },
    { id: 'amount', label: 'Amount' },
    { id: 'city', label: 'City' },
    { id: 'actions', label: 'Actions', disableSorting: true }
]

export function OrderDelivery({ orderDeliveries, cities,companyId ,allCities, allStates, states, countries, UpdateOrderDelivery, LoadOrderDeliveries, AddOrderDelivery, DeleteOrderDelivery }) {


    const classes = useStyles();
    const [recordForEdit, setRecordForEdit] = useState(null)
    const [filterFn, setFilterFn] = useState({ fn: items => { return items; } })
    const [openPopup, setOpenPopup] = useState(false)
    const [addOpenPopup, setAddOpenPopup] = useState(false)
    const [notify, setNotify] = useState({ isOpen: false, message: '', type: '' })
    const [confirmDialog, setConfirmDialog] = useState({ isOpen: false, title: '', subTitle: '' })
    const {
        TblContainer,
        TblHead,
        TblPagination,
        recordsAfterPagingAndSorting
    } = useTable(orderDeliveries, headCells, filterFn);
    console.log(recordsAfterPagingAndSorting);
    useEffect(() => {
        LoadOrderDeliveries(companyId)
        return () => {

        }
    }, [])

    const handleSearch = e => {
        let target = e.target;
        setFilterFn({
            fn: items => {

                if (target.value === "")
                    return items;
                else
                    return items.filter(x => x.cityName.toLowerCase().includes(target.value))
            }
        })
    }

    const addOrEdit = (OrderDelivery, resetForm) => {
        if (OrderDelivery.id === 0)
            AddOrderDelivery(OrderDelivery)
        else
            var data = { ...OrderDelivery, 'companyId': companyId }
        UpdateOrderDelivery(data)
        resetForm()
        // setRecordForEdit(null)
        setOpenPopup(false)
        setAddOpenPopup(false)
    }




    const addOrderDelivery = (OrderDelivery, resetForm) => {
        AddOrderDelivery(OrderDelivery)
        resetForm()
        setRecordForEdit(null)
        setAddOpenPopup(false)
        setOpenPopup(false)
    }

    const openInPopup = item => {
        setRecordForEdit(item)
        setOpenPopup(true)
    }

    const onDelete = id => {
        DeleteOrderDelivery(id)
        setConfirmDialog({
            ...confirmDialog,
            isOpen: false
        })
    }
    return (

        <div style={{}}>
            <Column flexGrow={1}>
                <StatComponent />
                <ToastContainer />
                <div style={{ margin: '10px 0px 0px 80px', width: '95%', }}>
                    <Controls.Input
                        label="Search City by City Name"
                        className={classes.searchInput}
                        InputProps={{
                            startAdornment: (<InputAdornment position="start">
                                <Search />
                            </InputAdornment>)
                        }}
                        onChange={handleSearch}
                    />
                </div>
                <Paper className={classes.pageContent}>
                    <h1>Order Delivery Setup</h1>
                    <Toolbar>
                        <Controls.Button
                            text="Add New"
                            variant="outlined"
                            startIcon={<AddIcon />}
                            className={classes.newButton}
                            onClick={() => { setAddOpenPopup(true); setRecordForEdit(null); }}
                        />
                    </Toolbar>
                    <TblContainer>
                        <TblHead />
                        <TableBody>
                            {

                                recordsAfterPagingAndSorting().map(item =>
                                (<TableRow key={item.id}>
                                    <TableCell>{item.timeSpan}</TableCell>
                                    <TableCell>{item.amount}</TableCell>
                                    <TableCell>{item.cityName}</TableCell>


                                    <TableCell>
                                        <Controls.ActionButton
                                            color="primary"
                                            onClick={() => {
                                                openInPopup(item)
                                            }}>
                                            <EditOutlinedIcon fontSize="small" />
                                        </Controls.ActionButton>
                                        <Controls.ActionButton
                                            color="secondary"
                                            onClick={() => {
                                                setConfirmDialog({
                                                    isOpen: true,
                                                    title: 'Are you sure to delete this record?',
                                                    subTitle: "You can't undo this operation",
                                                    onConfirm: () => { onDelete(item.id) }
                                                })
                                            }}>
                                            <CloseIcon fontSize="small" />
                                        </Controls.ActionButton>
                                    </TableCell>
                                </TableRow>)
                                )
                            }
                        </TableBody>
                    </TblContainer>
                    <TblPagination />
                </Paper>
                <Popup
                    title="Order Delivery Form"
                    openPopup={openPopup}
                    setOpenPopup={setOpenPopup}
                >
                    <OrderDeliveryForm
                        recordForEdit={recordForEdit}
                        addOrEdit={addOrEdit}
                        cities={allCities}
                        states={allStates}
                        countries={countries}
                    />
                </Popup>

                <Popup
                    title="Add Order Delivery Form "
                    openPopup={addOpenPopup}
                    setOpenPopup={setAddOpenPopup}
                >

                    <AddOrderDeliveryForm
                        recordForEdit={recordForEdit}
                        addOrderDelivery={addOrderDelivery}
                        states={states}
                        cities={cities}
                        countries={countries}
                    />
                </Popup>
                <Notification
                    notify={notify}
                    setNotify={setNotify}
                />
                <ConfirmDialog
                    confirmDialog={confirmDialog}
                    setConfirmDialog={setConfirmDialog}
                />
            </Column>

        </div>

    )
}





function mapStateToProps(state) {
    return {
        buttonloader: state.utilityReducer.buttonloader,
        user: state.userReducer.user,
        cities: state.pickUpStationReducer.cities,
        allCities: state.pickUpStationReducer.allCities,
        allStates: state.pickUpStationReducer.allStates,
        states: state.locationReducer.states,
        countries: state.locationReducer.countries,
        orderDeliveries: state.orderDeliveryReducer.orderDeliveries,
        companyId: state.persistReducer.companyId,


    };
}
const mapDispatchToProps = (dispatch) => ({

    UpdateOrderDelivery(payload) {
        dispatch({ type: "UPDATE_ORDERDELIVERY", payload });
    },

    LoadOrderDeliveries(payload) {
        dispatch({ type: "LOAD_ORDERDELIVERY", payload });
    },
    AddOrderDelivery(payload) {
        dispatch({ type: "ADD_ORDERDELIVERY", payload });
    },


    DeleteOrderDelivery(payload) {
        dispatch({ type: "DELETE_ORDERDELIVERY", payload });
    },

})

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(OrderDelivery);